export const bookData = [
    { id: 1, name: 'No Books' },
    { id: 2, name: 'Tome' },
    { id: 3, name: 'Grimoire' },
    { id: 4, name: 'Tome and Grimoire' }
];